/**
 * Rutas públicas útiles — derivadas de muxMembershipContract.ts
 */

import {
  MUX_MEMBERSHIP_TEMPLATE_CONTRACT,
  type MuxMembershipTemplateContract,
} from "@/config/muxMembershipContract";
import type { MuxSurfaceStatusKind } from "@/hooks/useMuxMembershipStatus";

export interface AdminVisitorLink {
  readonly to: string;
  readonly label: string;
  readonly hint: string;
  readonly template: string;
}

export interface AdminVisitorLinkGroup {
  readonly label: string;
  readonly description: string;
  readonly links: readonly AdminVisitorLink[];
}

function linksFromContract(rows: readonly MuxMembershipTemplateContract[]): AdminVisitorLink[] {
  return rows.flatMap((row) =>
    row.publicPaths.map((p) => ({
      to: p.path,
      label: p.label,
      hint: p.hint,
      template: row.template,
    })),
  );
}

export const ADMIN_VISITOR_LINK_GROUPS: readonly AdminVisitorLinkGroup[] = [
  {
    label: "Mux · Membresía",
    description: "Un enlace por ruta pública — estado alineado al hub de arriba",
    links: linksFromContract(MUX_MEMBERSHIP_TEMPLATE_CONTRACT),
  },
  {
    label: "Sitio base",
    description: "Contenido público sin funnel de membresía",
    links: [
      { to: "/biografia", label: "Biografía", hint: "Página bio principal", template: "" },
      { to: "/portfolio", label: "Portfolio", hint: "Galería pública", template: "" },
    ],
  },
] as const;

export function visitorLinkStatusLabel(status: MuxSurfaceStatusKind | undefined): string | null {
  if (!status) return null;
  if (status === "configured") return "Funciona";
  if (status === "fallback") return "Fallback";
  return "Roto";
}